import React from 'react';
import { Input, InputProps } from '@heroui/react';
import Typography from './typography/Typography';
import { InfoCircle } from './icons';
import { ResponsiveTooltip } from './ui';

interface CustomHeroInputProps extends Omit<InputProps, 'classNames'> {
  label: string;
  required?: boolean;
  error?: string;
  touched?: boolean;
  infoIconText?: string;
  className?: string;
  description?: string;
}

const CustomHeroInput: React.FC<CustomHeroInputProps> = ({
  label,
  required = false,
  error,
  touched,
  infoIconText,
  className = '',
  description,
  ...inputProps
}) => {
  const isPartner = window.location.pathname.startsWith('/partner');
  return (
    <div className={`flex flex-col ${className}`}>
      <div className="flex items-center gap-1 mb-2">
        {label && (
          <Typography
            variant="body2"
            className={error && touched ? 'text-auth-strength-weak' : 'text-auth-ink'}
          >
            {label}
            {required && (
              <span
                className={
                  error && touched
                    ? 'text-auth-strength-weak'
                    : `${isPartner ? 'text-partner' : 'text-primary'}`
                }
              >
                *
              </span>
            )}
          </Typography>
        )}
        {infoIconText && (
          <ResponsiveTooltip
            content={infoIconText}
            placement="top"
            classNames={{ content: 'max-w-xs' }}
          >
            <span className="cursor-pointer flex items-center">
              <InfoCircle />
            </span>
          </ResponsiveTooltip>
        )}
      </div>
      <Input
        {...inputProps}
        variant="bordered"
        className="w-full h-[2.375rem]"
        classNames={{
          inputWrapper: `border-auth-strength-none max-h-[2.375rem] min-h-[2.375rem] rounded-lg h-10 ${
            error && touched ? 'border-auth-strength-weak' : ''
          }`,
        }}
      />
      {description && (
        <Typography variant="body2" className="text-auth-muted text-mini leading-3.5 mt-1">
          {description}
        </Typography>
      )}
      {error && touched && (
        <Typography variant="body2" className={`text-auth-strength-weak text-xs`}>
          {error}
        </Typography>
      )}
    </div>
  );
};

export default CustomHeroInput;
